import { LeftHalfArrow } from "helper/icons"; 
import TooltipComponent from "shared/Components/tooltip";

const PageInfo = ({ title, onClick, children, isToolTip }) => {
  return (
    <div className="order-1">
      <div className="flex gap-2 items-center ml-4 justify-between py-3 md:p-0">
        <div className="flex gap-2 items-center">
          {!!onClick && (
            <button onClick={onClick} className="border rounded-md p-2">
              <LeftHalfArrow />
            </button>
          )}
          <p className="md:text-3xl font-bold text-purple-200 uppercase">
            {title}
          </p>
          {!!isToolTip && (
            <TooltipComponent />
          )}
        </div>
       {children}
      </div>
      <div className="border rounded-sm bg-300 w-full mb-4 mt-2"></div>
    </div>
  );
};

export default PageInfo;
